import { useStore } from 'vuex';

// **************************************
// ****  Misc Common Functions
// **************************************
const parseVinaEntityPageInfo = (response, entityType, listField) => {
    let entityPageInfo = {
        previousPageLink: null,
        nextPageLink: null,
        totalCount: null,
        successful: false
    };
    entityPageInfo[listField] = [];
    if (response.status != 200) throw Error(response.message);
    if (!response.data) return entityPageInfo;
    if (!response.data.entity_type) return entityPageInfo;
    if (response.data.entity_type != entityType) return entityPageInfo;
    let list = response.data.entities;
    if (!list) {
        return entityPageInfo;
    }
    if (typeof list != 'object') {
        return entityPageInfo;
    }
    entityPageInfo.successful = true;
    entityPageInfo[listField] = list;
    if (response.data.total_count !== undefined) {
        entityPageInfo.totalCount = response.data.total_count;
    }
    if (response.data._link) {
        if (response.data._link.previous_page) {
            entityPageInfo.previousPageLink = response.data._link.previous_page;
        }
        if (response.data._link.next_page) {
            entityPageInfo.nextPageLink = response.data._link.next_page;
        }
    }
    return entityPageInfo;
};

const parseVinaEntityEntry = response => {
    if (response.status != 200) throw Error(response.message);
    if (!response.data) return {};
    let entity = response.data;
    if (response.data._entry) {
        entity = response.data._entry;
    }
    if (typeof entity != 'object') {
        entity = {};
    }
    return entity;
};

const parseVinaEntityList = (response, entityType) => {
    if (response.status != 200) throw Error(response.message);
    if (!response.data) return [];
    if (!response.data.entity_type) return [];
    if (response.data.entity_type != entityType) return [];
    let entityList = response.data;
    if (response.data.entity_list) {
        entityList = response.data.entity_list;
    }
    if (!Array.isArray(entityList)) {
        entityList = [];
    }
    return entityList;
};

const getSearchUrl = function(baseUrl, searchInfo, searchCriteriaParams) {
    let pageSizeParam = 'page_size=200';
    if (searchInfo && searchInfo.pageSize) {
        pageSizeParam = `page_size=${searchInfo.pageSize}`;
    }
    let url = `${baseUrl}/search?${pageSizeParam}`;
    if (searchInfo && searchInfo.pageLink) {
       return `${url}&cursor=${searchInfo.pageLink}`;
    } else if (searchCriteriaParams) {
        return `${url}&${searchCriteriaParams}`;
    }
    return url;
};

const getOrganizationUuid = function() {
    const store = useStore();
    let activeUser = store.getters["user"];
    return activeUser.organizationUuid;
};

// ****************************************************************
// ****  Expose API Utility Method Calls to API Services
// ****************************************************************
export const dataUtils = {
    parseVinaEntityPageInfo,
    parseVinaEntityEntry,
    parseVinaEntityList,
    getSearchUrl,
    getOrganizationUuid
};